module.exports = __webpack_public_path__ + "static/world-tracking-icon-cd89c3e25d719fb27b390c92f188a56f.svg";